import styled from 'styled-components';

export const Root = styled.div`
  width: 90%;
  padding: 16px;
  margin-left: auto;
  margin-right: 0;
`;

export const Content = styled.div`
  border: none;
  cursor: default;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Image = styled.img`
  width: 16px;
`;

export const ValueContent = styled.div`
  display: flex;
`;
export const ClockContent = styled.div`
  flex: 1;
  padding-left: 4px;
`;
export const DesiredIconWrapper = styled.div`
  padding-left: 2px;
  padding-top: 2px;
`;
